import type { TrackingModule } from '../types';
import type { Platform } from '../../platform/Platform';
import type { ResourceMap } from '../../resources/types';
import type { MetaProperties } from './avo/Avo';

export class MarketingOptimizationTracking implements Partial<TrackingModule> {
  constructor(private readonly platform: Platform) { }

  public trackLevelWon(properties: {
    levelNumber: number;
    levelId: string;
    levelAttemptId: string;
    lives: number;
    doubleRewardShown: boolean;
    inventory: ResourceMap;
    metaProperties?: MetaProperties[];
  }): void {
    const { levelNumber } = properties;
    if (levelNumber <= 20 || levelNumber === 30 || levelNumber === 60) this.platform.logEvent(`Level_Complete_${levelNumber}`);
    this.platform.logEvent(
      'Level_Completed',
      undefined,
      {
        levelNumber: levelNumber.toString(),
      }
    );
  }
}
